export class TicketType
{
    public id: number;
    public name: Dictionary<string>;
    public seatCount: number;
    public seatPrice: number;
    public isFull: boolean;
    public alreadySignedUp: boolean;

    public constructor(data: { [key: string]: any })
    {
        this.id = data.id;
        this.name = data.name;
        this.seatCount = data.seatCount;
        this.seatPrice = data.seatPrice;
        this.isFull = data.isFull;
        this.alreadySignedUp = data.alreadySignedUp;
    }
}